export type Shortcut =
  | 'previous'
  | 'next'
  | 'back'
  | 'forward'
  | 'first'
  | 'last'
  | 'togglePlay'
  | 'openLightbox'
  | 'focusSearch'
  | 'closeLightbox'

const SHORTCUTS = new Map<string, Shortcut>([
  ['ArrowLeft', 'previous'],
  ['ArrowRight', 'next'],
  ['PageUp', 'back'],
  ['PageDown', 'forward'],
  ['Home', 'first'],
  ['End', 'last'],
  [' ', 'togglePlay'],
  ['f', 'openLightbox'],
  ['F', 'openLightbox'],
  ['/', 'focusSearch'],
  ['Escape', 'closeLightbox'],
])

const TYPING_TAGS = new Set(['INPUT', 'SELECT', 'TEXTAREA'])
const ACTIVATION_KEYS = new Set([' ', 'Enter'])
const CONTROL_SELECTOR = 'button, a[href], [role="button"], [role="checkbox"], [role="radio"], [role="tab"]'

const ownsKey = (target: EventTarget | null, key: string): boolean => {
  if (!(target instanceof HTMLElement)) return false
  if (TYPING_TAGS.has(target.tagName) || target.isContentEditable) return true
  if (target.closest('[role="slider"]')) return true
  return ACTIVATION_KEYS.has(key) && target.closest(CONTROL_SELECTOR) != null
}

export const shortcutFor = (event: KeyboardEvent): Shortcut | null => {
  if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey) return null
  if (ownsKey(event.target, event.key)) return null
  return SHORTCUTS.get(event.key) ?? null
}
